module.exports = __webpack_public_path__ + "h5/img/di9.18123329.png";